module.exports = __webpack_public_path__ + "img/BCC.07cd4447.svg";